// removed by extract-text-webpack-plugin
module.exports = {"tagsContainer":"_25Es8f09nVNMjsbZr-PbKA","tags":"_2tL4e88tOWWlgJ9jwbcp9o","engTags":"_2qYvJTWUuapfzduBhYrFdh","chtTags":"_1utTRCJ2211dxnbMQeGmbW","chtTag":"_3Z8tHqJmfyNTMoWi3xTPmH","active":"p8uc-X-Fmym3GC6fURH3M","engTag":"_1gHVM3ijLntdKRoAsfmBuo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project-tags/ProjectTags.css
// module id = 363
// module chunks = 0